

export const COUNTRY_CURRENCY_MAP: Record<string, "USD" | "EUR" | "GBP" | "AUD" | "INR" | "CAD" | "ZAR"> = {
  "United States": "USD",
  "Canada": "CAD",
  "Austria": "EUR",
  "Belgium": "EUR",
  "Cyprus": "EUR",
  "Estonia": "EUR",
  "Finland": "EUR",
  "France": "EUR",
  "Germany": "EUR",
  "Greece": "EUR",
  "Ireland": "EUR",
  "Italy": "EUR",
  "Latvia": "EUR",
  "Lithuania": "EUR",
  "Luxembourg": "EUR",
  "Malta": "EUR",
  "Netherlands": "EUR",
  "Portugal": "EUR",
  "Slovakia": "EUR",
  "Slovenia": "EUR",
  "Spain": "EUR",
  "United Kingdom": "GBP",
  "Australia": "AUD",
  "New Zealand": "AUD",
  "South Africa": "ZAR",
  "India": "INR",
};
